import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import _ from "lodash"
import "./index.css"

import { Button } from "../../../helpers";
import Steps from '../../../helpers/Steps';
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';

import Loading from "../../../common/Loading"
import googleChatIcon from "../../../images/google_chat_icon.png"

import { AddCompanyBranchUsersValidationSchema } from '../../../validation/companyBranchValidation';

import { validateInputs, combineISDCodeWithPhoneNumber, phoneNumberWithISDCode, getFullName, sortArrayOfObjectsInAlphabeticalOrder } from '../../../utils'


import { getCompanyWithGSTIN, insertBulkUsers } from '../../../services/api/company'
import { getUserRolesByCompanyId } from '../../../services/api/user';

import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { fetchCountries } from '../../../services/redux/reducers/commonThunk';
import { getGoogleUserChatUri } from '../../../services/api/googleChat';
import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';

import AddUsers from './components/AddUsers';


const AddCompanyUsers = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const loginUserId = useSelector((state) => state.userDetails.userId)
    const userDetails = useSelector((state) => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.activeUserRoleDetails.companyId)

    const [addUsersModalVisible, setAddUsersModalVisible] = useState(false)
    const [usersData, setUsersData] = useState([])
    const [companyData, setCompanyData] = useState({})
    const [formErrors, setFormErrors] = useState([])
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)

    const countriesData = useSelector(state => state.common.countries)

    useEffect(() => {
        getCompnayData()
        dispatch(fetchCountries())
    }, [])

    useEffect(() => {
        getUsersData()
    }, [companyData])

    const items = [
        {
            label: 'Company Details',
            command: () => { navigate(`/company/${id}`); }
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); }
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); }
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); }
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); }
        }
    ]

    if([2, 3].includes(companyData?.buyerSeller)){
        items.push(
            {
                label: 'Seller Profile',
                command: () => { navigate(`/company/seller-profile/${id}`); } 
            }
        )
    }

    const getCompnayData = async () => {
        const company_id = id
        const companyData = await getCompanyWithGSTIN(company_id)
        console.log("companyData-response", companyData)
        if (companyData.status = 1) {
            const company_data = companyData.data
            if (company_data) {
                setCompanyData(company_data)
            }
        }
    }

    const getUsersData = async () => {
        const data = {
            companyId: id,
            userStatusId: 1
        }
        const userRolesResponse = await getUserRolesByCompanyId(data)
        console.log("userRolesResponse", userRolesResponse)
        setIsLoaderVisible(false)
        if (userRolesResponse.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: userRolesResponse?.data?.error, life: 3000 }))
        } else {
            let userStringData = userRolesResponse.data.map(eachUserRole => {
                if (eachUserRole.user?.phoneNumber) {
                    eachUserRole.user.phoneNumber = phoneNumberWithISDCode(eachUserRole.user.phoneNumber)
                }
                return JSON.stringify(eachUserRole.user)
            })

            let uniqueUserData = Array.from(new Set(userStringData))
            uniqueUserData = uniqueUserData.map(eachUser => JSON.parse(eachUser))
            uniqueUserData = sortArrayOfObjectsInAlphabeticalOrder(uniqueUserData, "firstName")

            // setUsersData(uniqueUserData)
            constructUsersData(uniqueUserData)
        }
    }

    const constructUsersData = (usersData) => {
        if (usersData.length) {
            let updatedUsersData = usersData.map(eachUser => {
                let relatedUser = companyData.companyUsers?.find(eachCompanyUser => eachCompanyUser.userId === eachUser.userId)
                let roleNames = []
                let isCompanyLevelUser = false
                if (relatedUser && relatedUser.userRoles) {
                    relatedUser.userRoles.map(eachRole => {
                        if (eachRole.statusId === 1) {
                            let relatedCompanyRole = companyData.companyRoles?.find(eachCompanyRole => eachCompanyRole.companyRoleId === eachRole.companyRoleId)
                            if (relatedCompanyRole) {
                                roleNames.push(relatedCompanyRole.companyRoleName)
                            }

                            if(eachRole.branchId === 0 && !isCompanyLevelUser){
                                isCompanyLevelUser = true
                            }
                        }
                    })
                }
                eachUser.roleNames = roleNames
                eachUser.isCompanyLevelUser = isCompanyLevelUser
                return { ...eachUser }
            })

            setUsersData([...updatedUsersData])
        }
    }

    const handleAddCompanyBranchUsers = async (userList) => {
        const validation_res = await validateInputs(AddCompanyBranchUsersValidationSchema, userList, pmCompanyConfig)
        
        if (validation_res) {
            if (validation_res.error) {
                return
            }
            else {
                setFormErrors({})
                if(validation_res?.result?.length > 0){
                    validation_res.result.map(eachUser => {
                        eachUser.phoneNumber = combineISDCodeWithPhoneNumber(eachUser.ISDCode, eachUser.phoneNumber)
                        return eachUser
                    })
                }
                
                if (window.confirm("Do you want to add users..?")) {
                    setIsLoaderVisible(true)
                    let response = await insertBulkUsers(validation_res.result)
                    setIsLoaderVisible(false)
                    if (response?.failure) {
                        return dispatch(raiseToast({ severity: 'error', detail: response?.data?.error, life: 3000 }))
                    } else {
                        const data = response.data
                        const message = data?.message
                        if (data?.success) {
                            let { users, userRoles} = data
                            let newUsers = users.map(eachUser => {
                                let roleNames = []
                                userRoles.map(eachRole => {
                                    if (eachRole.statusId === 1 && eachUser.userId === eachRole.userId) {
                                        let relatedCompanyRole = companyData.companyRoles.find(eachCompanyRole => eachCompanyRole.companyRoleId === eachRole.companyRoleId)
                                        if (relatedCompanyRole) {
                                            roleNames.push(relatedCompanyRole.companyRoleName)
                                        }
                                    }
                                })
                            
                                eachUser.roleNames = roleNames

                                return {...eachUser}
                            })
                            
                            setUsersData([...usersData, ...newUsers])

                            setAddUsersModalVisible(false)
                            return dispatch(raiseToast({ severity: 'success', detail: 'Users added successfully', life: 3000 }))
                        }
                        else {
                            return dispatch(raiseToast({ severity: 'error', detail: message, life: 3000 }))
                        }
                    }
                }
            }
        }
    }

    const editUser = (rowData) => {
        return (
            <i className="pi pi-user-edit" onClick={() => navigate(`/editUser/${rowData.userId}`)} style={{ fontSize: '0.8rem', cursor: "pointer" }}></i>
        )
    }

    const handleGetGoogleUserChatUri = async (approvalEmail) => {
        if (!approvalEmail) {
            return dispatch(raiseToast({ severity: 'error', detail: "Approval user not found. Please contact tech team", life: 3000 }))
        }
        let data = {
            userId: userDetails.userId,
            emailId: approvalEmail
        }

        setIsLoaderVisible(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        setIsLoaderVisible(false)

        if (getGoogleUserChatUriRes.failure) {
            if (window.confirm("Chat with the user doesn't exist.\nPlease open chat manually, and send the message.")) {
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank')
            }
        } else {
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }

    const phoneNumberBody = (row) => {
        if (row.phoneNumber) {
            return (
                <div className='flex justify-content-center align-items-center'>
                    <p style={{ cursor: "pointer", padding: "0px", margin: "0px" }}>{row.phoneNumber}</p>
                    <div style={{ cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${row.phoneNumber}`)}>
                        <i className="pi pi-whatsapp pl-1 doc-copy-icon" style={{ color: "#00baaa" }}></i>
                    </div>
                </div>
            )
        }

        return "-"
    }

    const emailIdBody = (row) => {
        if (row.emailId) {
            return (
                <div className='flex justify-content-center align-items-center'>
                    <p onClick={() => navigate(`/editUser/${row.userId}`)} style={{ fontSize: "13px", cursor: "pointer", padding: "0px", margin: "0px" }}>{row["emailId"]}</p>
                    <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri(row.emailId)}>
                        <img
                            className="ml-1 mb-0 mt-0"
                            src={googleChatIcon}
                            style={{ height: 13 }}
                            alt="Google Chat"
                        />
                    </a>
                </div>
            )
        }

        return "-"
    }

    const userNameBody = (row) => {
        return getFullName(row.firstName, row.lastName)
    }

    const rowClassName = (user) => {
        if(user.roleNames?.length === 0){
            return "inactive-user-row-bg"
        }else if(user.isCompanyLevelUser){
            return "company-user-row-bg"
        }else{
            return "branch-user-row-bg"
        }
    }

    const userRolesBody = (row) => {
        if(row.roleNames?.length){
            return row.roleNames.join(", ")
        }

        return "No Active Roles"
    }

    let addUsersDisabledTooltipTxt = ""
    if (companyData.statusId === 2){
        addUsersDisabledTooltipTxt = "Adding users is disabled because the company is inactive."
    }
    
    return (
        <div className='container relative'>
            <div className="company-step-header" style={{ top: 50 }}>
                <Steps model={items} activeIndex={1} readOnly={false} />
            </div>
            <div className="p-card mb-3" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                <Toast ref={Toast} />
                <div className="flex justify-content-between">
                    <Tooltip target=".custom-target-icon" position="right" content="Please add users here - access can defined in Branches tab" />
                    <h5 className="">{companyData?.companyName} <i className="pi pi-info-circle custom-target-icon" style={{ fontSize: '0.8rem', cursor: 'pointer' }}></i></h5>
                    <Button className="mb-2 small-btn" onClick={() => setAddUsersModalVisible(true)} label="Add Users" permissions={id == 1 ? [27] : [133]} disabled={companyData.statusId === 2} tooltip={addUsersDisabledTooltipTxt} tooltipOptions={{position: "right", showOnDisabled: true}}></Button>
                </div>
                <div className="add-user-table">
                    <DataTable value={usersData} responsiveLayout="scroll" rowClassName={rowClassName}>
                        {/* <Column field="firstName" header="First Name" ></Column>
                        <Column field="lastName" header="Last Name" ></Column> */}
                        <Column field="" header="User Name" body= {userNameBody} ></Column>
                        <Column field="phoneNumber" header="Phone Number" body= {phoneNumberBody} ></Column>
                        <Column field="emailId" header="Email Id" body= {emailIdBody}></Column>
                        <Column field="" header="Roles" body= {userRolesBody} style={{width: "300px"}}></Column>
                        <Column field="edit" header="Edit" body={editUser} ></Column>
                    </DataTable>
                </div>
                <Dialog className='add-users-dialog' header="Add Users" visible={addUsersModalVisible} style={{ width: '', minHeight: "35%" }} onHide={() => setAddUsersModalVisible(false)}>
                    <AddUsers 
                        companyId={id}
                        countriesData={countriesData}
                        handleAddCompanyBranchUsers={handleAddCompanyBranchUsers}
                    />
                </Dialog>
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default AddCompanyUsers;
